import { render, staticRenderFns } from "./ed-p.vue?vue&type=template&id=efa2d12c&scoped=true&"
import script from "./ed-p.ts?vue&type=script&lang=js&"
export * from "./ed-p.ts?vue&type=script&lang=js&"
import style0 from "./ed-p.scss?vue&type=style&index=0&id=efa2d12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa2d12c",
  null
  
)

export default component.exports